/**
 * Where a claimant's compensation may be paid, as this app offers it.
 *
 * ⚠️ ONE definition, imported by the intake form and by the ERP submit modal. Both write the same
 * column — `payee_bank` on the claim, `bank_name` on a saved account — and the customer app's own
 * picker reads it back by value (`IssueBank.fromApiValue`). A bank spelled differently on one of
 * the two screens is a bank that app cannot match, so it opens the claimant's account form with no
 * card chosen rather than theirs.
 *
 * The values are the customer app's `IssueBank.apiValue`, exactly: the bank's NAME and not a code,
 * because `customers.bank_name` already holds `ທະນາຄານ BCEL` written by the COD sync, and a code
 * here would stand two spellings of one bank side by side in the picker.
 *
 * The column itself is free text (max 64), which is why `OTHER_BANK` exists rather than this being
 * a closed set. A claimant who banks elsewhere is still a claimant whose account an officer has to
 * be able to record — being unable to record one is the defect these two screens exist to close.
 */
export const PAYEE_BANKS = ['BCEL One', 'LDB'];

/** Not a bank: the select's escape hatch, never sent. Read the screen's own `payeeBank` instead. */
export const OTHER_BANK = '__other__';

/**
 * `StorePayoutAccountRequest`'s own rule for an account number, applied before the form is sent
 * rather than after: a 422 on the last field of a long intake costs the whole screen.
 *
 * Digits, spaces and dashes. The dash sits LAST in the class rather than escaped — eslint's
 * `no-useless-escape` refuses the `\-` the PHP rule is written with, and the class is the same.
 */
export const ACCOUNT_NO = /^[0-9 -]+$/;

/**
 * The server's own length limits — identical on `StoreClaimRequest` (payee_*) and
 * `StorePayoutAccountRequest` — checked before sending for the same reason as `ACCOUNT_NO`.
 */
export const PAYEE_MAX = { name: 191, bank: 64, account_no: 64 };

/** The error for a value over its limit, or '' when it fits. */
export const tooLong = (value, max) => (value.length > max ? `ບໍ່ເກີນ ${max} ຕົວອັກສອນ` : '');

export default PAYEE_BANKS;
